import { render, staticRenderFns } from "./NoSharesDialog.vue?vue&type=template&id=24a34518"
import script from "./NoSharesDialog.vue?vue&type=script&lang=js"
export * from "./NoSharesDialog.vue?vue&type=script&lang=js"
import style0 from "./NoSharesDialog.vue?vue&type=style&index=0&id=24a34518&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports